export interface DonutDatum {
  key?: string;
  label: string;
  value: number;
  color: string;
}

interface DonutProps {
  data: DonutDatum[];
  total: number;
  centerLabel?: string;
}

export function Donut({ data, total, centerLabel = '总计' }: DonutProps) {
  const radius = 60;
  const cx = 80;
  const cy = 80;
  const circumference = 2 * Math.PI * radius;

  let offset = 0;
  const slices = data.map((d) => {
    const pct = total > 0 ? d.value / total : 0;
    const dash = pct * circumference;
    const gap = circumference - dash;
    const slice = { ...d, dash, gap, offset };
    offset += dash;
    return slice;
  });

  return (
    <div className="donut">
      <svg className="donut__svg" viewBox="0 0 160 160">
        {slices.map((s, i) => (
          <circle
            key={i}
            cx={cx}
            cy={cy}
            r={radius}
            fill="none"
            stroke={s.color}
            strokeWidth={20}
            strokeDasharray={`${s.dash} ${s.gap}`}
            strokeDashoffset={-s.offset}
          />
        ))}
      </svg>
      <div className="donut__center">
        <div className="donut__num">{total}</div>
        <div className="donut__label">{centerLabel}</div>
      </div>
    </div>
  );
}

export default Donut;
